/**
 * Initialize date pickers.
 */

(() => {
    let date_pickers = document.querySelectorAll('.js-date-picker');

    if (!date_pickers.length) {
        return;
    }

    date_pickers.forEach((date_picker) => {
        new DatePickerDialog(date_picker);
    });
})();
